/**
 * MONSTER TOWN — ROUTINES + GENTLE NEEDS. ROUTINE CREW (src/routine/**).
 *
 * One `installRoutines(ctx)` line in `main.ts`, and this is what it turns on:
 *
 *   `src/content/routines.ts`  DATA — every rhythm in the town, and the two
 *                              windows when the game is glad to see a kid eat
 *                              or sleep. A new neighbour is one line here.
 *   `places.ts`                turns a place tag into somewhere to stand,
 *                              checked against the layout the kid actually built
 *   `director.ts`              sends the neighbours through their day and empties
 *                              the street at night
 *   `invitations.ts`           the kid's own two gentle needs, and the bed that
 *                              takes them to the morning
 *
 * NOTHING HERE CAN BE FAILED, MISSED, OR RUSHED (LAW #2), and nothing here gates
 * anything at all — a need cannot close a door, a schedule cannot close a shop.
 * Both files say so at the top and the shapes of the types back it up.
 */

import type { GameContext } from '../app/context'
import { registerRoutineContent } from '../content/routines'
import { installDirector, routineReport, sweepNow } from './director'
import { bubbleState, installInvitations, offerNow } from './invitations'
import { registerRoutineHarness } from './demos'

let installed = false

export function installRoutines(ctx: GameContext): void {
  if (installed) return
  installed = true
  // The tables and the need windows are content; they are registered here so a
  // crew that forgets to install us gets a town with no rhythm, never a town
  // with half a rhythm.
  registerRoutineContent()
  installDirector()
  installInvitations(ctx)
  registerRoutineHarness()
  // `installHarness()` runs after every crew and re-registers its placeholder
  // angles, so claim ours again once boot has finished (same as `npc/demos.ts`).
  setTimeout(() => registerRoutineHarness(), 0)
}

export { routineReport, sweepNow, bubbleState, offerNow }
